

const suffixPending = `${process.env.REACT_APP_PROMISE_TYPE_DELIMITER}${JSON.parse(process.env.REACT_APP_ASYNC_ACTION_TYPES)[0]}`;

const suffixFulfilled = `${process.env.REACT_APP_PROMISE_TYPE_DELIMITER}${JSON.parse(process.env.REACT_APP_ASYNC_ACTION_TYPES)[1]}`;

const suffixRejected = `${process.env.REACT_APP_PROMISE_TYPE_DELIMITER}${JSON.parse(process.env.REACT_APP_ASYNC_ACTION_TYPES)[2]}`;


export { suffixPending, suffixFulfilled, suffixRejected };
